<template>
  <div class="pv">
    <div class="pv__canvas" :class="{ 'pv__canvas--done': done }">
      <span v-if="!done && !run" class="pv__canvas-idle">🖼️</span>
      <template v-if="run && !done">
        <div class="pv__canvas-glow" :style="{ background: `linear-gradient(135deg,rgba(212,169,70,.08) ${progress * 0.8}%,rgba(0,200,245,.05) ${progress}%,transparent ${progress + 10}%)` }"></div>
        <div class="pv__pixels">
          <div
            v-for="(b, i) in pixels"
            :key="i"
            class="pv__pixel"
            :style="{ background: i < progress * 0.4 ? 'rgba(212,169,70,.25)' : i < progress * 0.3 ? 'rgba(0,200,245,.15)' : 'rgba(255,255,255,.04)', transition: `background .1s ${i * 0.008}s` }"
          ></div>
        </div>
        <div class="pv__spark">✨</div>
      </template>
      <div v-if="done" class="pv__done-box">
        <span class="pv__done-icon">👗</span>
        <div class="pv__done-text">
          <div class="pv__done-title">AI生成完成</div>
          <div class="pv__done-sub">高清商品图 1200×1200</div>
        </div>
      </div>
    </div>
    <div class="pv__bar">
      <div class="pv__bar-fill" :style="{ width: progress + '%' }"></div>
    </div>
    <div class="pv__status" :style="{ color: done ? '#4CAF7A' : run ? '#D4A946' : '#8A95B0' }">
      {{ done ? '✓ 图片生成完成' : run ? `AI生成中 ${Math.round(progress)}%` : '等待生成' }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrevAIImage',
  props: { run: { type: Boolean, default: false } },
  data() {
    return {
      progress: 0,
      done: false,
      timer: null,
      pixels: Array.from({ length: 40 }, () => ({}))
    }
  },
  watch: {
    run(v) {
      if (this.timer) clearInterval(this.timer)
      if (!v) { this.progress = 0; this.done = false; return }
      this.timer = setInterval(() => {
        if (this.progress >= 100) { clearInterval(this.timer); this.done = true; return }
        this.progress += 2.5
      }, 40)
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.pv { width: 100%; text-align: center; }
.pv__canvas {
  width: 100%;
  aspect-ratio: 16 / 10;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 8px;
  position: relative;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(255, 255, 255, .1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: border-color .5s;
}
.pv__canvas--done { border-color: rgba(212, 169, 70, .4); }
.pv__canvas-idle { font-size: 28px; opacity: .3; }
.pv__canvas-glow {
  position: absolute;
  inset: 0;
  transition: background .04s;
}
.pv__pixels {
  position: absolute;
  inset: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  padding: 6px;
}
.pv__pixel {
  flex: 0 0 calc(10% - 2px);
  aspect-ratio: 1;
  border-radius: 2px;
}
.pv__spark {
  position: relative;
  z-index: 1;
  font-size: 22px;
  animation: gx-pulse 1s infinite;
}
.pv__done-box {
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #1a2855, #2d4a22);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  animation: gx-checkPop .4s ease-out both;
}
.pv__done-icon { font-size: 28px; }
.pv__done-text { text-align: left; }
.pv__done-title { font-size: 10px; color: #D4A946; font-weight: 600; }
.pv__done-sub { font-size: 9px; color: #00C8F5; }
.pv__bar {
  height: 4px;
  border-radius: 2px;
  background: rgba(255, 255, 255, .08);
  overflow: hidden;
  margin-bottom: 5px;
}
.pv__bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #D4A946, #00C8F5);
  border-radius: 2px;
  transition: width .04s;
}
.pv__status { font-size: 10px; }
</style>
